import { createGlobalStyle } from 'styled-components';

import { baseColor } from 'views/services/color-scheme';

export const HtmlStyle = createGlobalStyle`
  html {
    background-color: ${baseColor};
  }
`